var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 16,
  fill: "none",
  viewBox: "0 0 11 8"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.192.293a1 1 0 0 1 0 1.414L4.536 7.364a1 1 0 0 1-1.414 0l-2.83-2.83a1 1 0 1 1 1.415-1.413l2.122 2.122L8.778.293a1 1 0 0 1 1.414 0"
})));
export default SvgCheck;